Hideaways.welcome = function() {
    var welcome = new Welcome();
    welcome.init();

    Hideaways._welcome = welcome;
}
